import { Navigate } from "react-router-dom";
import type { ReactNode } from "react";

import { useAuth } from "@/contexts/AuthContext";

/** Route guard for pages inside /admin that only admins (not trainers)
 *  may enter. Non-admin staff is bounced to the trainings list. */
export function AdminOnly({ children }: { children: ReactNode }) {
  const { user } = useAuth();
  if (!user?.is_admin) {
    return <Navigate to="/admin/trainings" replace />;
  }
  return <>{children}</>;
}
